import { addValue, removeStrValue } from './text';

export const passportFormatting = (str) => {
  const removedStrValue = removeStrValue(str);
  if (removedStrValue.length > 0) {
    const cutLength = removedStrValue.substr(0, 10);
    return addValue(cutLength, 4, ' ');
  }
  return removedStrValue;
};